export const SeedConservationServices = [
    {
        serviceTitle: "Seed Banking",
        serviceText: "Professional storage and preservation of indigenous seeds in controlled environments to maintain genetic diversity and viability for future generations.",
        serviceTicks: [
            "Climate-controlled storage",
            "Genetic testing & documentation",
            "Long-term preservation"
        ]
    },
    {
        serviceTitle: "Regeneration Programs",
        serviceText: "Active cultivation and multiplication of rare and endangered indigenous varieties to restore their populations and availability to farmers.",
        serviceTicks: [
            "Variety multiplication",
            "Quality assurance",
            "Distribution networks"
        ]
    },
    {
        serviceTitle: "Farmer Training",
        serviceText: "Comprehensive education and training programs to teach traditional and modern seed conservation techniques to local farming communities.",
        serviceTicks: [
            "Hands-on workshops",
            "Technical support",
            "Community networks"
        ]
    }
];

export const BioServices = [
    {
        serviceTitle: "Preparation and Production",
        serviceText: "",
        serviceTicks: [
            "Biofertilizers: Made from compost, manure, crop residues, and microbial cultures.",
            "Biopesticides: Derived from plants like neem, chili, and garlic, or microbial agents.",
            "Workshops: Step by step guidance on mixing, fermenting, and preparing safe formulations."
        ]
    },
    {
        serviceTitle: "Application in Farms",
        serviceText: "",
        serviceTicks: [
            "Soil enrichment: Applying biofertilizers to boost nutrient uptake and soil structure.",
            "Pest management: Spraying biopesticides to protect crops without harming pollinators.",
            "Demonstration plots: Practical training on dosage, timing, and integration with traditional practices"
        ]
    },
];

export const MarketServices = [
    {
        serviceTitle: "Market Mapping and Establishment",
        serviceText: "",
        serviceTicks: [
            "Local focus: Identifying strategic community locations for organic markets",
            "Farmer participation: Organizing farmer groups to supply directly",
            "Infrastructure support: Setting up stalls, storage, and basic facilities"
        ]
    },
    {
        serviceTitle: "Farmer-to-Market Linkages",
        serviceText: "",
        serviceTicks: [
            "Direct supply: Farmers sell produce without intermediaries",
            "Income generation: Ensuring fair returns and consistent market access",
            "Capacity building: Training farmers on quality standards and consumer engagement"
        ]
    },
    {
        serviceTitle: "Consumer Engagement",
        serviceText: "",
        serviceTicks: [
            "Healthy eating awareness: Educating communities on the benefits of organic food",
            "Food tracing: Building consumer capacity to understand where food comes from",
            "Trust building: Promoting transparency and accountability in food systems"
        ]
    },
];

export const AdvocacyServices = [
    {
        serviceTitle: "Seed Advocacy",
        serviceText: "We believe farmers should control their seeds. That means the right to save, share, exchange, and store seeds without restrictions.",
        serviceTicks: [
            "Preserving Indigenous Seeds: We conserve traditional crops like millet, sorghum, legumes, and indigenous vegetables, ensuring biodiversity and climate resilience.",
            "Community Seed Systems: Our seed banks and farmer-led regeneration programs strengthen local access to quality seeds.",
            "Policy Engagement: We advocate for laws and policies that recognize farmers as custodians of biodiversity and protect their rights to manage seeds."
        ]
    },
    {
        serviceTitle: "Advocacy on Harmful Agrochemical misuse",
        serviceText: "Farming should be productive without harming people or the environment.",
        serviceTicks: [
            "Raising Awareness: We educate farmers and communities on the dangers of synthetic fertilizers and pesticides.",
            "Promoting Agroecology: Through composting, biopesticides, and ecological pest management, we help farmers adopt chemical-free, regenerative practices.",
            "Environmental Protection: Our work preserves soil health, water quality, and biodiversity, ensuring sustainable ecosystems for generations to come."
        ]
    },
    {
        serviceTitle: "Market Advocacy",
        serviceText: "Farmers should benefit fairly from the foods they grow.",
        serviceTicks: [
            "Fair & Inclusive Markets: We create opportunities for indigenous crops to reach consumers directly, reducing exploitation by middlemen.",
            "Economic Empowerment: We support value addition, local processing, and market access that improves farmer incomes.",
            "Consumer Awareness: By promoting the nutritional, cultural, and environmental value of indigenous foods, we create demand for sustainable diets and local foods."
        ]
    },
];

export const YouthAndWomenEmpowermentServices = [
    {
        serviceTitle: "Capacity Building and Training",
        serviceText: "We equip youth and women with the skills to lead in agroecology and seed conservation:",
        serviceTicks: [
            "Seed Conservation Skills: Training on selecting, regenerating, and storing indigenous seeds to preserve biodiversity and cultural heritage.",
            "Agroecology Training: Teaching sustainable farming practices such as composting, biopesticides, ecological pest management, and soil restoration.",
            "Entrepreneurship and Market Skills: Mentorship in value addition, processing, and marketing of indigenous crops to increase income and livelihood opportunities."
        ]
    },
    {
        serviceTitle: "Advocacy on Harmful Agrochemical misuse",
        serviceText: "Farming should be productive without harming people or the environment.",
        serviceTicks: [
            "Raising Awareness: We educate farmers and communities on the dangers of synthetic fertilizers and pesticides.",
            "Promoting Agroecology: Through composting, biopesticides, and ecological pest management, we help farmers adopt chemical-free, regenerative practices.",
            "Environmental Protection: Our work preserves soil health, water quality, and biodiversity, ensuring sustainable ecosystems for generations to come."
        ]
    },
    {
        serviceTitle: "Leadership and Community Roles",
        serviceText: "Youth and women are empowered to take leadership in community seed banks and local farming initiatives:",
        serviceTicks: [
            "Seed Bank Management: Leading collection, preservation, and distribution of seeds within communities.",
            "Peer-to-Peer Mentorship: Serving as trainers and ambassadors to share knowledge with other farmers.",
            "Community Representation: Engaging in local decision-making and advocacy to shape policies that support sustainable agriculture and farmer rights."
        ]
    },
    {
        serviceTitle: "Market Access and Economic Empowerment",
        serviceText: "We help youth and women access fair markets and transform agriculture into a viable business:",
        serviceTicks: [
            "Inclusive Market Participation: Connecting youth- and women-led farms to local and organic markets.",
            "Value Addition: Supporting processing, packaging, and branding of indigenous crops to enhance income.",
            "Agroecology Entrepreneurship: Encouraging innovative, climate-smart farming ventures that provide employment and opportunity."
        ]
    },
    {
        serviceTitle: "Knowledge Sharing and Community Engagement",
        serviceText: "We foster intergenerational learning and collaboration:",
        serviceTicks: [
            "Mentorship Programs: Youth learn from experienced farmers; women share traditional seed knowledge with the next generation.",
            "Workshops and Community Events: Seed fairs, training days, and cultural food events bring communities together to strengthen networks.",
            "Nutrition and Food Security: Women and youth lead initiatives to improve household diets and promote indigenous foods."
        ]
    },
];